import React, { useState } from 'react';
import styled from 'styled-components';
import { ConsoleInput as MainInput, ConsoleLabel as MainLabel, FieldError } from '../../styles/common/input.styled';
import { Button } from '../../styles/common/Button.styled';
import Modal from '../common/Modal';
import { uploadAudioFile } from '../../api/audio';
import toast from 'react-hot-toast';

interface AudioUploadModalProps {
  file: File;
  onClose: () => void;
  onSuccess: () => void;
}

const FormGroup = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const FileInfo = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.color.text_color_200};
  margin-bottom: 16px;
  padding: 12px;
  background-color: ${({ theme }) => theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)'};
  border-radius: 8px;

  strong {
    color: ${({ theme }) => theme.color.text_color_100};
  }
`;

const AudioUploadModal: React.FC<AudioUploadModalProps> = ({ file, onClose, onSuccess }) => {
  const [name, setName] = useState(file.name.split('.')[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [fieldError, setFieldError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setFieldError('음원 명칭을 입력해 주세요.');
      toast.error('음원 명칭을 입력해 주세요.');
      return;
    }

    setIsLoading(true);
    try {
      await uploadAudioFile({
        name,
        file
      });
      toast.success(`${name} 업로드 성공`);
      onSuccess();
      onClose();
    } catch (error) {
      toast.error('업로드에 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal title="음원 등록" onClose={onClose} width={420} historyMode="none" footer={<><Button $variant="secondary" onClick={onClose}>취소</Button><Button type="submit" form="audio-upload-form" disabled={isLoading}>{isLoading ? '처리 중...' : '업로드'}</Button></>}>
        <form id="audio-upload-form" onSubmit={handleSubmit}>

          <FileInfo>
            파일명: <strong>{file.name}</strong>
          </FileInfo>

          <FormGroup>
            <MainLabel htmlFor="audio-upload-form-name">음원 명칭</MainLabel>
            <MainInput aria-invalid={Boolean(fieldError)} aria-describedby={fieldError ? "audio-upload-form-name-error" : undefined} id="audio-upload-form-name"
              type="text"
              value={name}
              onChange={(e) => { setName(e.target.value); setFieldError(''); }}
              placeholder="음원 명칭을 입력하세요"
              autoFocus
            />
            {fieldError && <FieldError id="audio-upload-form-name-error">{fieldError}</FieldError>}
          </FormGroup>


        </form>
    </Modal>
  );
};

export default AudioUploadModal;
